import { initialState } from "./state"

export default {
  resetList: state => {
    const init_state = initialState()
    Object.keys(state).forEach(key => {
      state[key] = init_state[key]
    })
  },
  setCurrentStep: (state, payload) => (state.currentStep = payload),
  setIsFiltering: (state, payload) => (state.isFiltering = payload),
  setIsLoadingScreen: (state, payload) => (state.isLoadingScreen = payload),
  setCategorieFilter: (state, payload) => (state.categorieFilter = payload),
  setOfferFilter: (state, payload) => (state.offerFilter = payload),
  setCampaignFilter: (state, payload) => (state.campaignFilter = payload),
  setSvaFilter: (state, payload) => (state.svaFilter = payload),
  removeFilterKey(state, { filterType, key }) {
    if (!state[filterType]) return

    const filter = { ...state[filterType] }
    delete filter[key]

    state[filterType] = filter
  }
}